// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___Nu93","content":"styles_content__28Maq"};